import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoadingScreenComponent } from '@rillion/core/loading-screen/loading-screen.component';
import { AsyncPipe } from '@angular/common';
import { InitializeService } from '@rillion/core/services/initialize.service';

@Component({
  standalone: true,
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [RouterOutlet, LoadingScreenComponent, AsyncPipe],
})
export class AppComponent {
  private readonly initializationService = inject(InitializeService);

  appComponentInitializing$ = this.initializationService.appComponentInitializing$;
}
